import React from 'react';

interface MaintenanceIconProps {
  className?: string;
}

const MaintenanceIcon: React.FC<MaintenanceIconProps> = ({ className = '' }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" r="3" stroke="currentColor" strokeWidth="1" fill="none"/>
    <path d="M8 1v2M8 13v2M15 8h-2M3 8H1M12.5 3.5l-1.4 1.4M4.9 11.1l-1.4 1.4M12.5 12.5l-1.4-1.4M4.9 4.9L3.5 3.5" stroke="currentColor" strokeWidth="1"/>
  </svg>
);

export default MaintenanceIcon;